export default "<p>currency works!</p>\n"